<template>
  <div class="login-container">
    <div id="titlebar">
      <div id="dragbar" />
      <div class="version-info">{{ version }}</div>
    </div>
    <div class="login-content fullscreen">
      <main>
        <slot />
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  emits: {
    nextStep: () => true,
    prevStep: () => true,
  },

  setup() {
    return {
      version: __APP_VERSION__,
    };
  },
});
</script>

<style scoped lang="scss">
#titlebar {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: $z-index-modal;

  .version-info {
    font-size: 11px;
    opacity: 0.6;
    padding-inline-end: 16px;
    @include themed() {
      color: t($grey-50);
    }
  }
}

#dragbar {
  flex: 1;
  height: 100%;
}

.login-container {
  position: relative;
  display: flex;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-items: center;
  justify-content: center;
  flex-direction: column;
  @include themed() {
    background-color: t($bg);
  }

  @include media("<=medium") {
    height: auto;
    min-height: 100vh;
  }

  .login-content {
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-items: center;
    flex: 1;
    z-index: $z-index-content-elevated;
    margin-top: -128px; // offset the wave height

    &.fullscreen {
      display: flex;
      width: 100%;
    }

    &.embed {
      display: flex;
      text-align: unset;
      align-items: unset;
      max-width: fit-content;
    }

    main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      height: fit-content;

      :deep(.logo) {
        width: 65px;
        height: 33px;
      }

      :deep(h1) {
        @extend %font-h2;
        margin: 32px 0 8px 0;
        @include themed() {
          color: t($primary);
        }
      }

      :deep(h2) {
        @extend %font-page-regular;
        padding: 0 24px;
        margin-top: 0;
        @include themed() {
          color: t($grey-60);
        }
      }
    }
  }

  .wave {
    position: absolute;
    bottom: 0;
    z-index: $z-index-content;
  }
}
</style>
